import { Gabarito } from './../../../../models/gabarito.model';
import { IdentificadorService } from './../../../../services/admin/identificador.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Regua } from './../../../../models/regua.model';
import { GabaritoService } from './../../../../services/admin/gabarito.service';
import { ReguaService } from './../../../../services/admin/regua.service';
import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-quest-finalizou',
  templateUrl: './quest-finalizou.component.html',
  styleUrls: ['./quest-finalizou.component.css'],
})
export class QuestFinalizouComponent implements OnInit {

  public reguas: Regua[] = null;
  public gabaritos: Gabarito[] = null;
  public pontos: any = null;
  public erro: any = null;
  public identificadorId: any = null;
  public dadosIdentificador: any = null;

  constructor(
    private reguaService: ReguaService,
    private gabaritoService: GabaritoService,
    private identificadorService: IdentificadorService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.pontuacao();
    this.readReguas();
    this.readIdentificador();
    this.showRespostas();
  }

  public pontuacao(): void {
    this.identificadorId = this.route.snapshot.paramMap.get('identificador');

    this.gabaritoService.pontuacaoQuestionario(this.identificadorId).subscribe(
      (res: any) => {
        this.pontos = res;
      },
      (error: any) => {
        this.erro = error;
        this.gabaritoService.toastError(
          'Erro ao buscar pontuação do questionario respondido. Sistema indisponível, tente novamente !'
        );
      }
    );
  }

  public readReguas(): void {
    this.reguaService.read().subscribe(
      (res: Regua[]) => {
        this.reguas = res;
      },
      (error: any) => {
        this.erro = error;
        this.reguaService.toastError(
          'Erro ao buscar Réguas. Sistema indisponível, tente novamente !'
        );
      }
    );
  }

  public readIdentificador(): void {
    this.identificadorService.readByIdentificador(this.identificadorId).subscribe(
      (res: any) => {
        this.dadosIdentificador = res;
      },
      (error: any) => {
        this.erro = error;
        this.identificadorService.toastError(
          'Erro ao buscar Identificador do questionário. Sistema indisponível, tente novamente !'
        );
      }
    );
  }

  public showRespostas(): void {

    this.gabaritoService.respostasQuestionario(this.identificadorId).subscribe(
      (res: Gabarito[]) => {
        this.gabaritos = res;
      },
      (error: any) => {
        this.erro = error;
        this.gabaritoService.toastError(
          'Erro ao buscar Respostas do questionário. Sistema indisponível, tente novamente !'
        );
      }
    );
  }

  public modalVerRespostas(): void {
    $('#modalVerRespostas').modal();
  }
}
